import TextArea from "antd/es/input/TextArea";
import React, { useEffect } from "react";
import { MdKeyboardBackspace } from "react-icons/md";
import BatchRunOutput from "../BatchRunOutput/BatchRunOutput";
import { quick_Action_Run_Save_Execute_Batch_Success } from "../../../../Redux/Actions/user/RunQuickActionSaveExecuteBatch";
import { useDispatch } from "react-redux";

const UploadOwnData = ({
  back,
  setTextAreaData,
  quickrunStatusData,
  setAccessLevel,
  QuickSaveExecuteResponse,
  setQuickSaveExecuteResponse,
  setShowAccessError,
  setuplpad,
  setShowOutput,
  setBatchProcessing,
  params,
}) => {
  const handlechanage = (e) => {
    setTextAreaData(e.target.value);
  };

  useEffect(() => {
    setQuickSaveExecuteResponse("");
  }, []);
  const dispatch = useDispatch();
  return (
    <div>
      <div
        className="new-workspace-back-master"
        onClick={() => {
          back(false);
          setAccessLevel("");
          setShowAccessError(false);
          setTextAreaData("");
          setuplpad("");
        }}
      >
        <MdKeyboardBackspace />
        Back
      </div>
      <TextArea rows={8} className="own-data-font" onChange={handlechanage} />
      {(quickrunStatusData?.result || QuickSaveExecuteResponse) && (
        <BatchRunOutput
          data={quickrunStatusData}
          QuickSaveExecuteResponse={QuickSaveExecuteResponse}
          back={back}
          setAccessLevel={setAccessLevel}
          setuplpad={setuplpad}
          setShowOutput={setShowOutput}
          setBatchProcessing={setBatchProcessing}
          params={params}
        />
      )}
    </div>
  );
};

export default UploadOwnData;
